import { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../../firebase/firebase';
import { onBlur, ValidationState } from '../auth.props';
import { FeedbackMessage, Spin } from '../../../components';
import { ImageGame } from '../../../assets';
import { ROUTES } from '../../../routes';

const CompleteProfile = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [errors, setErrors] = useState<ValidationState>({});

  const allOk =
    (name.length > 0 &&
      lastName.length > 0 &&
      birthDate.length > 0 &&
      !errors.name &&
      !errors.lastName &&
      !errors.birthDate) ||
    loading;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const user = auth.currentUser;

    if (!user) return;

    setLoading(true);

    try {
      await updateDoc(doc(db, 'users', user.uid), {
        name,
        lastName,
        birthDate,
      });

      navigate(ROUTES.HOME);
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        general: 'Error al guardar, inténtalo de nuevo.',
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="isg-auth-page">
      <img
        src={ImageGame}
        alt="Imperial Stones Game"
        className="isg-auth-image-bg"
      />

      <div className="isg-auth-form-container">
        <h1>COMPLETAR PERFIL</h1>

        <form className="isg-auth-form-box" onSubmit={handleSubmit}>
          <input
            className="isg-input"
            placeholder="Nombre"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={(e) => onBlur(e.target.value, 'name', setErrors)}
            required
          />

          {errors.name?.length ? (
            <FeedbackMessage message={errors.name} />
          ) : null}

          <input
            className="isg-input"
            placeholder="Apellidos"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            onBlur={(e) => onBlur(e.target.value, 'lastName', setErrors)}
            required
          />

          {errors.lastName?.length ? (
            <FeedbackMessage message={errors.lastName} />
          ) : null}

          <input
            className="isg-input"
            type="date"
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
            onBlur={(e) => onBlur(e.target.value, 'birthDate', setErrors)}
            required
          />

          {errors.birthDate?.length ? (
            <FeedbackMessage message={errors.birthDate} />
          ) : null}

          {errors.general ? <FeedbackMessage message={errors.general} /> : null}

          <button
            className={`isg-form-button ${!allOk ? 'disabled' : ''}`}
            type="submit"
            disabled={!allOk}
          >
            <p className={loading ? 'loading' : ''}>
              <Spin spin={loading} size={20} className="isg-spin-floating" />
              Guardar
            </p>
          </button>
        </form>
      </div>
    </div>
  );
};

export default CompleteProfile;
